const sommeDesNombresDefinis = (...nombres) => {
  let total = 0
  nombres.forEach(nombre => {
    if (typeof (nombre) === 'number' && !isNaN(nombre)) {
      total += nombre
    }
  })

  return total
}

const equalDecimals = (nombreA, nombreB) => {
  return Math.abs(nombreA - nombreB) < 0.0000001
}


export {
  equalDecimals,
  sommeDesNombresDefinis
}
